export const FeatureFlags = {
  NOOK_INITIAL_LAUNCH: 'fyf-thenook-initallaunch',
  NAV_V2NAV_KILLSHOP: 'nav-v2nav-killshop',
};
